export const en = {
    'expander-error': 'The forecast is temporarily unavailable',
    'expander-header': 'Add banners',
    'expander-no-data': 'Try turning off or broadening some of the user profile characteristics',
    increase: 'Expand coverage'
};
